import * as R from 'remeda';

/*
  Record pages documented at https://bullhorn.github.io/OpenWindow-Links/. Note is absent because it
  only has an Add form, and CorporateUser because no record route for it has been verified.
*/
const OPEN_WINDOW_RECORD_ENTITIES = [
  'Candidate',
  'ClientContact',
  'ClientCorporation',
  'JobOrder',
  'Placement',
  'Lead',
  'Opportunity',
] as const;

export type OpenWindowRecordEntity = (typeof OPEN_WINDOW_RECORD_ENTITIES)[number];

// Callers holding a runtime string narrow it here before they can build a link.
export const isOpenWindowRecordEntity = R.isIncludedIn(OPEN_WINDOW_RECORD_ENTITIES);

export function bullhornLink(entity: OpenWindowRecordEntity, id: string | number, view?: string) {
  const base = `https://bullhornstaffing.com/BullhornSTAFFING/OpenWindow.cfm?Entity=${entity}&id=${encodeURIComponent(id)}`;
  return view ? `${base}&view=${encodeURIComponent(view)}` : base;
}
